/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Detail = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        name: {
    type: 'string',
    isRequired: true,
},
        details: {
    type: 'array',
    contains: {
        type: 'DataDetail',
    },
    isRequired: true,
},
    },
};